import { useQuery, useQueryClient } from "@tanstack/react-query";
import { orderDetails } from "../../../../services/orderService";
import TicketDetails from "./details/ticketDetails";
import { ticketDetails } from "../../../../services/ticketService";
import { useEffect } from "react";

const ManageTicket = ({ data }) => {
  const queryClient = useQueryClient();
  const { data: details } = useQuery({
    queryKey: ["ticketDetails", data?._id],
    queryFn: async () => {
      const res = await ticketDetails({ id: data?._id });
      return res;
    },
    enabled: !!data?._id,
  });

  useEffect(() => {
    return () => {
      queryClient.removeQueries({ queryKey: ["ticketDetails", data?._id] });
    };
  }, []);

  return (
    <div>
      <TicketDetails details={details?.data} />
    </div>
  );
};

export default ManageTicket;
